import { Box, ToggleButton, ToggleButtonGroup, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { pickingprocesstype } from "../../../../utils/staticEnums";

import { AnimatePresence, motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useConfirmConceptJobMutation, useCreateConceptJobMutation, useGetFilterCountQuery } from "../../../../newapi/pickingjob/pickingjobSlice";
import { useGetWarehousesSelectQuery } from "../../../../newapi/warehouse/warehouseApiSlice";
import { tokens } from "../../../../theme";
import { showToastMessagePostRequest, showToastMessageRequestError } from "../../../../utils/toasts";
import SHModalBottom from "../../../theme/Modal/SHModalBottom";
import Subheading from "../../../theme/text/Subheading";
import { CheckBatchBody, CheckBatchFooter } from "./views/CheckBatchView";
import { StartCreatebatchBody, StartCreatebatchFooter, StartCreatebatchTitle } from "./views/StartCreateBatchView";
import { MConfirmEditBatch } from "./MConfirmEditBatch";
import { addAction } from "../../../../newapi/global/actionProgressSlice";
import { useDispatch } from "react-redux";

const defaultCreateBatchStructure = (t) => {
    
    return {
        'user': { 
            id:-1,
            name:t("no_selection")
        },
        'shipper':  {
            id:-1,
            name: t("all")
        },
        'shipperProfile':  {
            id:-1,
            name: t("all")
        },
        'reachtype': {
            id:-1,
            name: t("all")
        },
        'relation': {
            id:-1,
            name: t("all")
        },
        'stream': {
            id:-1,
            name: t("no_selection")
        },
        'cart': {
            id:-1,
            barcode: t("no_selection")

        },
        'product' : [],
        'warehousezone': [],
        'warehouse': {
            id:-1,
            name: t("no_selection")
        },
        'pickingCrates': [],
    }
};

const MCreateBatch = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [orderAmount,setOrderAmount] = useState('');

    const dispatch = useDispatch();

    const [optionMap, setOptionMap] = useState(defaultCreateBatchStructure(t));
    const tabs = ['startcreate','checkbatch'];
    const [tab,setTab] = useState(tabs[0]);
    const [changes, setChanges] = useState({
        ordersToRemove: [],
        orderChanges: [],
    });

    useEffect(() => {
        setTab(tabs[0]);
        setOptionMap(defaultCreateBatchStructure(t));
        setChanges({
            ordersToRemove: [],
            orderChanges: [],
        });
    },[props.open])

    const getFilterIds = (options) => ({
        shipper: options.shipper?.id ?? -1,
        shipperProfile: options.shipperProfile?.id ?? -1,
        reachtype: options.reachtype?.id ?? -1,
        relation: options.relation?.id ?? -1,
        stream: options.stream?.id ?? -1,
        product:options.product?.map(z => z.id) ?? [],
        warehousezone: options.warehousezone?.map(z => z.id) ?? [],
        warehouseId: options.warehouse.id ?? -1,
        ...(options.stream.cartScan && { barcode: options.cart.barcode}),
        ...(options.stream.pickingProcessType === pickingprocesstype.CART_CRATE && {
            pickingCrates: options.pickingCrates.map(c => c.trim()).filter(c => c.length > 0)
        }),
    });

    const getWarehouseZones = () => {

        return optionMap.warehousezone?.map(z => z.id) ?? [];
    }
    const getProducts = () => {

        return optionMap.product?.map(z => z.id) ?? [];
    }
    
    const { data: filterCount, isLoading, isFetching } = useGetFilterCountQuery(getFilterIds(optionMap));
    // const { data: warehouseData, isLoading:warehouseLoading } = useGetWarehousesSelectQuery();

    const [createConceptJob,{isLoading:createJobLoading}] = useCreateConceptJobMutation();
    const [confirmConceptJob, {isLoading: isConfirming}] = useConfirmConceptJobMutation();

    const handleClose = () => {
        props.handleClose();
    }
      
    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    useEffect(() => {
        if(filterCount?.orderCount < orderAmount) {
            setOrderAmount(filterCount.orderCount);

            toast.warning(t("new_max_message"), {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    },[filterCount])

    const [streamError,setStreamError] = useState(null);
    const [cartError,setCartError] = useState(null);
    const [userError,setUserError] = useState(null);
    const [warehouseError,setWarehouseError] = useState(null);
    const [amountError,setAmountError] = useState(null);
    const [pickingCratesError,setPickingCratesError] = useState(null);
    const [groupBy, setGroupBy] = useState("shipper");

    const handleGroupByChange = (_event, value) => {
        if (value !== null) {
            setGroupBy(value);
        }
    };

    const [createdJob,setCreatedJob] = useState(null);

    const [mConfirmEditBatchOpen,setMConfirmEditBatchOpen] = useState(false);

    const handleSaveChanges = (options) => {
        const cleanedChanges = {
            ...options,
            ordersToRemove: changes.ordersToRemove,
            orderChanges: changes.orderChanges.map(({ id, shipperId, shipperProfileId }) => ({
                id,
                shipperId,
                shipperProfileId,
            })),
        };

        confirmConceptJob({
            jobId: createdJob?.pickingJobId,
            ...cleanedChanges,
        })
        .unwrap()
        .then(res => {
            showToastMessagePostRequest(t, res);
            dispatch(addAction({
                type: "shipping_progress",
                entityType: "pickingjob", 
                entityId: createdJob?.pickingJobId,
            }));
            handleClose();
        })
        .catch(err => {
            showToastMessageRequestError(t("confirm_failed"), t, err);
        });
    };

    const handleSave = () => {
        setUserError(null);
        setStreamError(null);
        setAmountError(null);
        setWarehouseError(null);
        setPickingCratesError(null);

        if(optionMap.user.id === -1) {
            setUserError(t("user_required"));
            return;
        }

        if(optionMap.warehouse.id === -1) {
            setWarehouseError(t("warehouse_required"));
            return;
        }

        if(optionMap.stream.id === -1) {
            setStreamError(t("stream_required"));
            return;
        }
        if(optionMap.stream.cartScan && optionMap.cart.id === -1) {
            setCartError(t("cart_required"));
            return;

        }

        if(optionMap.stream.pickingProcessType === pickingprocesstype.CART_CRATE) {
            const validCrates = optionMap.pickingCrates.map(c => c.trim()).filter(c => c.length > 0);
            if(validCrates.length === 0) {
                setPickingCratesError(t("picking_crates_required"));
                return;
            }
        }

        if(orderAmount > filterCount.orderCount) {
            setAmountError(t("cant_exceed_max"))
            return;
        }

        createConceptJob({
            ...getFilterIds(optionMap),
            user: optionMap.user,
            orderAmount: orderAmount ? parseInt(orderAmount, 10) : filterCount?.orderCount
        })
        .unwrap()
        .then(res => {
            setCreatedJob(res);
            showToastMessagePostRequest(t, res);
            setTab(tabs[1])
        })
        .catch(err => {
            showToastMessageRequestError(t("create_failed"),t, err);
        })

        
    }


    return(
        <SHModalBottom
            open={props.open}
            onClose={handleClose}
            sx={{
                body: {
                    // your styles
                }
            }}
        >
            <Box 
                sx={{
                    paddingY:3,
                    paddingX:3,
                    display:"flex",
                    flexDirection:"column",
                }}
            >
                <AnimatePresence mode="wait">
                    {tab === tabs[0] ? (
                        <motion.div
                            key="startcreate"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.15, ease: "easeInOut" }}
                            style={{ height: "100%", width: "100%" }}
                        >
                            <StartCreatebatchTitle
                                setOptionMap={setOptionMap}
                                optionMap={optionMap}
                                warehouseError={warehouseError}
                                userError={userError}
                            />
                        </motion.div>
                    ) : (
                        <motion.div
                            key="checkbatch"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.15, ease: "easeInOut" }}
                            style={{ height: "100%", width: "100%" }}
                        >
                             <Box
                                sx={{
                                    display:"flex",
                                    alignItems:"center",
                                    justifyContent:"space-between",
                                }}
                            >
                                <Subheading>{t("check_batch")}</Subheading>
                                <ToggleButtonGroup
                                    value={groupBy}
                                    exclusive
                                    onChange={handleGroupByChange}
                                    size="small"
                                    sx={{
                                        background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                                        borderRadius: 5,
                                        p:0.5,
                                        '& .MuiToggleButtonGroup-grouped': {
                                            border: 0,
                                            px: 2,
                                        borderRadius: 4,
                                            py: 0.5,
                                            fontFamily: "Roboto,sans-serif",
                                            fontSize: 14,
                                            fontWeight: 500,
                                            textTransform: 'none',
                                            '&.Mui-selected': {
                                                background: theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                                                color: theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
                                                '&:hover': {
                                                    background: theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                                                },
                                            },
                                            '&:not(.Mui-selected)': {
                                                // background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                                                color: colors.txt["secondary"],
                                            },
                                        },
                                    }}
                                >
                                    <ToggleButton value="shipper">{t("shipper")}</ToggleButton>
                                    <ToggleButton value="relation">{t("relation")}</ToggleButton>
                                </ToggleButtonGroup>
                            </Box>
                        </motion.div>
                    )}
                </AnimatePresence>
                
            </Box>

            {/* BODY */}
            <Box
                sx={{
                    flex:1,
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    borderTopLeftRadius:16,
                    borderTopRightRadius:16,
                    display:"flex",
                    flexDirection:"column",
                    overflow:'hidden',
                    transition:"250ms"
                }}
            >
                <AnimatePresence mode="wait">
                    {tab === tabs[0] ? (
                        <motion.div
                            key="startcreate"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.15, ease: "easeInOut" }}
                            style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "auto", width: "100%" }}
                        >
                            <StartCreatebatchBody
                                getFilterIds={getFilterIds}
                                optionMap={optionMap}
                                setOptionMap={setOptionMap}
                                streamError={streamError}
                                amountError={amountError}
                                cartError={cartError}
                                pickingCratesError={pickingCratesError}
                                getProducts={getProducts}
                                isLoading={isLoading}
                                isFetching={isFetching}
                                filterCount={filterCount}
                                setOrderAmount={setOrderAmount}
                                orderAmount={orderAmount}
                                getWarehouseZones={getWarehouseZones}
                            />
                        </motion.div>
                    ) : (
                        <motion.div
                            key="checkbatch"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.15, ease: "easeInOut" }}
                            style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "auto", width: "100%" }}
                        >
                            <CheckBatchBody
                                job={createdJob}
                                groupBy={groupBy}
                                changes={changes}
                                setChanges={setChanges}
                            />
                        </motion.div>
                    )}
                </AnimatePresence>
            </Box>
            <Box
                component="footer"
                sx={{
                    
                    display:"block",
                    width:1,
                    paddingBottom: isStandAlone ? "32px" : "16px",
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    paddingRight:3,
                    zIndex:1058,
                    position:"relative",
                    paddingTop:2,
                    background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    borderBottomLeftRadius:24,
                    borderBottomRightRadius:24,
                    "@media screen and (max-width: 47.9375em)" : {
                        paddingRight:0,
                    }
                }}
            >

                <AnimatePresence mode="wait">
                    {tab === tabs[0] ? (
                        <motion.div
                            key="startcreate"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.15, ease: "easeInOut" }}
                            style={{ height: "100%", width: "100%",
                                    display:"flex",
                                    alignItems:"center",
                                    justifyContent:"space-between", }}
                        >
                            <StartCreatebatchFooter
                                handleSave={handleSave}
                                handleClose={handleClose}
                                createJobLoading={createJobLoading}
                            />
                        </motion.div>
                    ) : (
                        <motion.div
                            key="checkbatch"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.15, ease: "easeInOut" }}
                            style={{ height: "100%", width: "100%",
                                    display:"flex",
                                    alignItems:"center",
                                    justifyContent:"space-between", }}
                        >
                            <CheckBatchFooter
                                handleChange={() => {setMConfirmEditBatchOpen(true)}}
                                isLoading={isConfirming}
                                goBack={handleClose}
                            />
                        </motion.div>
                    )}
                </AnimatePresence>
                
            </Box>

            <MConfirmEditBatch
                handleClose={(toContinue, options) => {
                    if(toContinue){
                        handleSaveChanges(options);
                    }
                    setMConfirmEditBatchOpen(false);
                }}
                open={mConfirmEditBatchOpen}
            />
        </SHModalBottom>
    )
}

export default MCreateBatch;
